import { makeSimpleDomRect } from './dom.js';

function expandRect(rect, amount) {
    return makeSimpleDomRect(rect.x - amount, rect.y - amount, rect.width + amount * 2, rect.height + amount * 2);
}

export { expandRect };
//# sourceMappingURL=rect.js.map
